module.exports = __webpack_public_path__ + "32562ea54b66a048a7d093eb6f595faa.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/mdi/fonts/materialdesignicons-webfont.woff2?v=2.2.43
// module id = 954
// module chunks = 1